import React from "react";
import "./button.css";
function BtnGreen(props) {
  const {
    onClick = () => {},
    title = "",
    disabled = false,
    type = "button",
  } = props;
  return (
    <div>
      <button
        onClick={onClick}
        disabled={disabled}
        type={type}
        className="btn-out-section-green"
      >
        {title}
      </button>
    </div>
  );
}

export default BtnGreen;
